import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import { UniversalImg5 } from "../../Constant/Index";
const Otp = () => {
    const [countdown, setCountdown] = useState(3540); // 59 minutes * 60 seconds

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const minutes = Math.floor(countdown / 60);
    const seconds = countdown % 60;
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/newpassword');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading="Forgot Password" />
            <section className="auth-section">
                <div className="container">
                    <div className="auth-start">
                        <div className="row">
                            <div className="col-lg-7 col-md-6 order-1 order-md-0 mt-5 mt-md-0">
                                <div className="row">
                                    <div className="col-xl-2 col-lg-1"></div>
                                    <div className="col-xl-7 col-lg-8"  data-aos="fade-left" data-aos-duration="800">
                                        <div className="form-area">
                                            <h2 className="md-heading pb-1 mb-4">Enter OTP Code</h2>
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="d-flex">
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                            <div className="col-2 mb-4 px-1 px-md-2">
                                                                <div className="form-group">
                                                                    <input type="text" maxLength="1" name="" id="" className="form-control px-0 text-center" placeholder="0" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-4">
                                                        <p className="timer-box-otp text mb-0 text-center">
                                                            Time Remaining : {minutes < 10 ? '0' : ''}{minutes}:{seconds < 10 ? '0' : ''}{seconds}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-12 mb-4">
                                                        <div className="form-submit">
                                                            <button type="submit" className="btn d-block w-100">Submit</button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-4">
                                                        <div className="other-option">
                                                            <p className="text mediam-font">Didn’t Receive the OTP ?  <a href="" className="semibold-font">Resend Code</a></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6">
                                <figure className="with-bg with-hover"  data-aos="fade-right" data-aos-duration="800">
                                    <img src={UniversalImg5} className="auth-img w-100 with-boxes with-raduis" alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    )
}
export default Otp;